import {
  GETUPDATECOMMOMCONFDETAILS_SUCCESS,
  GETUPDATECOMMOMCONFDETAILS_FAILED,
  RESET_GETUPDATECOMMOMCONFDETAILS,
  LOADING_GETUPDATECOMMOMCONFDETAILS,
  NETWORK_ERROR_GETUPDATECOMMOMCONFDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETUPDATECOMMOMCONFDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETUPDATECOMMOMCONFDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETUPDATECOMMOMCONFDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETUPDATECOMMOMCONFDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETUPDATECOMMOMCONFDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
